import apiPaths from '../api-paths';

export default {
  get({ year }) {
    return axios.get(`${ apiPaths.API }/zus/fixed-asset-settlement/${ year }`);
  },
};
